import ExternalSystem from '@/store/models/external-system'
export default function (sys) {
  return new ExternalSystem(sys)
}
